import * as React from 'react'

import { CmsComponentSlot } from '@grandvisionhq/bloomreach'
import { CustomerSupportContainer } from '@grandvisionhq/customer-support'
import { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'

import { withCms, withLayout } from '../cms'

import '@grandvisionhq/customer-support/dist/index.css'

const CustomerSupportPage: NextPage = () => (
  <>
    <CmsComponentSlot path="main/top-container" />
    <CustomerSupportContainer isCustomerIDActivated={true} showConsent={true} />
    <CmsComponentSlot path="main/bottom-container" />
  </>
)

export default compose(withCms(), withLayout())(CustomerSupportPage)
